import { Button, Col, Container, Row } from "react-bootstrap";
import "./Members.css";
import Memberimg from "../../assets/members.svg";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";
import Login from "../login/Login";


function Members() {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [newPhotos, setNewPhotos] = useState([]);
  const [filteredNewPhotos, setFilteredNewPhotos] = useState([]);
  const [searchOldPhotosTerm, setSearchOldPhotosTerm] = useState("");
  const [searchNewPhotosTerm, setSearchNewPhotosTerm] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    fetchMembers();
    const token = localStorage.getItem("jwt");
    if (!token) {
      setShow(true);
    }
  }, []);

  useEffect(() => {
    fetchnewPhotos();
    const token = localStorage.getItem("jwt");
    if (!token) {
      setShow(true);
    }
  }, []);

  useEffect(() => {
    if (!show) {
      console.log("Popup closed");
    }
  }, [show]);


  const handleDataTransfer = (data) => {
    console.log("Received from modal:", data);
    fetchMembers();
    fetchnewPhotos();
  };

  const fetchMembers = () => {
    const token = localStorage.getItem("jwt");

    axios
      .get(baseUrl + "/app/members/", {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then(async (response) => {
        setMembers(response.data);
        setFilteredMembers(response.data);
        console.log("Members: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log("Error fetching members:", error);
      });
  };

  const fetchnewPhotos = () => {
    const token = localStorage.getItem("jwt");

    axios
      .get(baseUrl + "/app/new-members-image/", {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then(async (response) => {
        setNewPhotos(response.data);
        setFilteredNewPhotos(response.data);
        console.log("New Photos: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log("Error fetching new photos:", error);
      });
  };


  const handleSearchOldPhotos = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchOldPhotosTerm(value);

    const filtered = members.filter((member) =>
      member.name.toLowerCase().includes(value)

    );

    setFilteredMembers(filtered);
  };


  const handleSearchNewPhotos = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchNewPhotosTerm(value);

    const filtered = newPhotos.filter((photo) =>
      photo.name?.toLowerCase().includes(value) ||
      photo.address?.toLowerCase().includes(value)

    );

    setFilteredNewPhotos(filtered);
  };

  return (
    <>
      <Container>
        {members.length === 0 && (
          <div>
            <Login
              show={show}
              handleClose={() => setShow(false)}
              sendData={handleDataTransfer}
            />
          </div>
        )}

        {members.length !== 0 && (
          <section className="members" id="members">
            <Container>
              <Tabs
                defaultActiveKey="profile"
                id="uncontrolled-tab-example"
                className="newOldTab my-5"
              >
                <Tab eventKey="home" title="Old Photos" >
                  <Container>
                    <div className="search">
                      <input
                        type="search"
                        placeholder="Search Old Photos..."
                        className="search-bar"
                        value={searchOldPhotosTerm}
                        onChange={handleSearchOldPhotos}
                      />
                    </div>
                  </Container>
                  <Row className="members-row py-5 my-5">
                    {filteredMembers.length > 0 ? (
                      filteredMembers.map((item, index) => (
                        <Col
                          lg={4}
                          md={6}
                          className="members-image d-flex align-items-center flex-column"
                          key={index}
                        >
                          <div className="border-shape pt-3">
                            <img src={item.image || Memberimg} className="" alt="Member" />
                          </div>
                          <div className="member-name py-3">{item.name}</div>
                          <div className="member-address py-4">{item.address}</div>
                          <div className="member-no">
                            {item.phone ? (
                              <a href={`tel:${item.phone}`}>{item.phone}</a>
                            ) : (
                              <span>No phone number available</span>
                            )}
                          </div>
                          {item.link && (
                            <div className="view-more ">
                              <a href={item.link} target="_blank" rel="noopener noreferrer">
                                <Button className="view-more-btn">
                                  Registration
                                </Button>
                              </a>
                            </div>
                          )}
                        </Col>
                      ))
                    ) : (
                      <p className="text-center mt-4">No members found</p>
                    )}
                  </Row>
                </Tab>
                <Tab eventKey="profile" title="New Photos">
                  <Container>
                    <div className="search">
                      <input
                        type="search"
                        placeholder="Search New Photos..."
                        className="search-bar mb-2" 
                        value={searchNewPhotosTerm}
                        onChange={handleSearchNewPhotos}
                      />
                    </div>
                  </Container>
                  <Row className="members-row py-5 my-5">
                    {filteredNewPhotos.length > 0 ? (
                      filteredNewPhotos.map((item, index) => (
                        <Col
                          lg={4}
                          md={6}
                          className="members-image d-flex align-items-center flex-column"
                          key={index}
                        >
                          <div className="border-shape pt-3">
                            <img src={item.new_image || Memberimg} className="" alt="Member" />
                          </div>
                          <div className="member-name py-3">{item.name}</div>
                          <div className="member-address py-4">{item.address}</div>
                          <div className="member-no">
                            {item.phone ? (
                              <a href={`tel:${item.phone}`}>{item.phone}</a>
                            ) : (
                              <span>No phone number available</span>
                            )}
                          </div>
                          {item.link && (
                            <div className="view-more ">
                              <a href={item.link} target="_blank" rel="noopener noreferrer">
                                <Button className="view-more-btn">
                                  Registration
                                </Button>
                              </a>
                            </div>
                          )}
                        </Col>
                      ))
                    ) : (
                      <p className="text-center mt-4">No new photos available</p>
                    )}
                  </Row>
                </Tab>
              </Tabs>
            </Container>
          </section>
        )}
      </Container>
    </>
  );
}

export default Members;
